import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  employeesTimes: {}
}

export default function employeesTimesReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_EMPLOYEES_TIMES:
      return {...state, loading: action.payload}
    case actions.GET_EMPLOYEES_TIMES:
      return {...state, employeesTimes: action.payload}
    default:
      return state
  }
}